// extracted by mini-css-extract-plugin
export default {"Box":"base-cell-module__Box--mil_H","editingCell":"base-cell-module__editingCell--RrIhv","disallowSelection":"base-cell-module__disallowSelection--I91qy"};